import { TRuleWithTheme } from "@ackee/fela";

export const container: TRuleWithTheme = ({ theme: { colors } }) => ({
    position: 'relative',

    ':hover': {
        '> div > div': {
            backgroundColor: colors.fuchsia,
        },
        '> span': {
            display: 'block',
        },
    },
});

export const buttonContainer: TRuleWithTheme = ({ theme: { cursors } }) => ({
    width: '3rem',
    marginRight: '-0.5rem',
    height: '2.125rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...cursors.circle,
});

export const inner: TRuleWithTheme<{ active: boolean }> = ({ theme: { colors }, active }) => ({
    marginLeft: '-1px',
    width: active ? '0.5625rem' : '0.3125rem',
    height: active ? '0.5625rem' : '0.3125rem',
    willChange: 'background-color',
    transition:
        'cubic-bezier(0.4, 0.0, 0.2, 1) background 0.3s, cubic-bezier(0.4, 0.0, 0.2, 1) width 0.2s, cubic-bezier(0.4, 0.0, 0.2, 1) height 0.2s',
    backgroundColor: active ? colors.fuchsia : colors.blue,
    border: 'none',
    WebkitAppearance: 'none',
});

export const divider: TRuleWithTheme = ({ theme: { colors } }) => ({
    width: '0.0625rem',
    height: '2rem',
    marginLeft: '1.45rem',
    marginTop: '-0.625rem',
    marginBottom: '-0.625rem',
    backgroundColor: colors.black,
    opacity: 0.2,
    pointerEvents: 'none',
});

export const extendText: TRuleWithTheme<{ active: boolean; itemsVisible: boolean }> = ({ theme: { colors }, active, itemsVisible }) => ({
    display: itemsVisible ? 'block' : 'none',
    position: 'absolute',
    transform: 'translateX(calc(-100% - 0.5625rem)) translateY(-100%)',
    whiteSpace: 'nowrap',
    border: `0.0625rem solid ${active ? colors.fuchsia : colors.blue}`,
    padding: '5px 8px',
    margin: 0,
    background: active ? colors.fuchsia : colors.white,
    color: active ? colors.white : colors.blue,
    transition:
        'cubic-bezier(0.4, 0.0, 0.2, 1) background 0.3s, cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s, cubic-bezier(0.4, 0.0, 0.2, 1) border-color 0.3s',
});
